if (!customElements.get("slider-component")) {
  class SliderComponent extends HTMLElement {
    constructor() {
      super();

      this.resizeObserver = new ResizeObserver(() => this.initPages());

      this.boundUpdate = this.update.bind(this);
      this.boundOnButtonClick = this.onButtonClick.bind(this);
      this.boundOnBubbleClick = this.onBubbleClick.bind(this);
    }

    connectedCallback() {
      // Wait until the DOM inside the custom element exists
      requestAnimationFrame(() => {
        this.initialize();
      });
    }

    initialize() {
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

      this.currentPageElement = this.querySelector(".slider-counter--current");
      this.pageTotalElement = this.querySelector(".slider-counter--total");

      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      this.bubbles = this.querySelectorAll(".slider-bubbles svg");

      if (!this.slider) return;

      this.initPages();
      this.initEventListeners();
      this.initMobileSliderDots();
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();

      this.slider?.removeEventListener("scroll", this.boundUpdate);

      this.prevButton?.removeEventListener("click", this.boundOnButtonClick);
      this.nextButton?.removeEventListener("click", this.boundOnButtonClick);

      this.bubbles.forEach((bubble) =>
        bubble.removeEventListener("click", this.boundOnBubbleClick)
      );
    }

    initPages() {
      this.sliderItemsToShow = [...this.sliderItems].filter(
        (item) => item.clientWidth > 0
      );

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset =
        this.sliderItemsToShow.length > 1
          ? this.sliderItemsToShow[1].offsetLeft -
            this.sliderItemsToShow[0].offsetLeft
          : this.sliderItemsToShow[0].clientWidth;

      if (this.pageTotalElement) {
        this.pageTotalElement.innerText = this.sliderItemsToShow.length;
      }

      this.update();
    }

    initEventListeners() {
      this.resizeObserver.observe(this.slider);

      this.slider.addEventListener("scroll", this.boundUpdate);

      this.prevButton?.addEventListener("click", this.boundOnButtonClick);
      this.nextButton?.addEventListener("click", this.boundOnButtonClick);

      this.bubbles.forEach((bubble) =>
        bubble.addEventListener("click", this.boundOnBubbleClick)
      );
    }

    initMobileSliderDots() {
      const pageIndex = this.currentPageElement;

      if (!pageIndex || !this.bubbles.length) return;

      const observer = new MutationObserver(() => {
        this.updateBubbles(Number(pageIndex.innerText));
      });

      observer.observe(pageIndex, {
        childList: true,
        characterData: true,
        subtree: true,
      });

      this.updateBubbles(1);
    }

    update() {
      if (!this.sliderItemOffset) return;

      const currentIndex =
        Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.innerText = currentIndex;
      }

      this.updateBubbles(currentIndex);
    }

    updateBubbles(currentIndex) {
      this.bubbles.forEach((bubble, index) => {
        const circle = bubble.querySelector("circle");

        if (!circle) return;

        circle.setAttribute(
          "fill",
          index === currentIndex - 1 ? "#041E42" : "#CAD0D9"
        );
      });
    }

    onButtonClick(event) {
      if (!this.sliderItemOffset) return;

      event.preventDefault();

      const direction =
        event.currentTarget.name === "next" ? 1 : -1;

      this.slider.scrollBy({
        left: direction * this.sliderItemOffset,
        behavior: "smooth",
      });
    }

    onBubbleClick(event) {
      if (!this.sliderItemOffset) return;

      const index =
        Number(event.currentTarget.id.split("-").pop()) - 1;

      this.slider.scrollTo({
        left: index * this.sliderItemOffset,
        behavior: "smooth",
      });
    }
  }

  customElements.define("slider-component", SliderComponent);
}